import { Controller } from "@hotwired/stimulus";
import * as Turbo from "@hotwired/turbo";

// Connects to data-controller="support--search"
export default class extends Controller {
  static targets = ["input", "results"];
  static values = { url: String, debounce: { type: Number, default: 350 } };

  // TypeScript property declarations for targets and values
  declare inputTarget: HTMLInputElement;
  declare resultsTarget: HTMLElement;
  declare hasResultsTarget: boolean;
  declare urlValue: string;
  declare debounceValue: number;

  private debounceTimeout?: number;

  connect() {
    // No-op
  }

  search() {
    clearTimeout(this.debounceTimeout);
    this.debounceTimeout = window.setTimeout(() => {
      this.performSearch();
    }, this.debounceValue ?? 350);
  }

  searchTopic(event: Event) {
    event.preventDefault();
    clearTimeout(this.debounceTimeout);

    const topic = (event.currentTarget as HTMLElement).dataset.topic ?? "";
    this.inputTarget.value = topic;
    this.performSearch();
  }

  performSearch() {
    const query = this.inputTarget.value;
    const url = `${this.urlValue ?? ""}?q=${encodeURIComponent(query)}`;

    // Use Turbo to fetch results and update the results target
    const frameId = this.hasResultsTarget ? this.resultsTarget.id : "search-results";
    Turbo.visit(url, {
      action: "replace",
      frame: frameId
    });
  }
}

